import Home from './Home';
import Instruction from './Instruction';
import Register from './Register';
import Score from './Score';

export default class UI {
  constructor() {}
  init() {
    this.homeScr = new Home();
    this.homeScr.init();

    this.instrScr = new Instruction();
    this.instrScr.init();

    this.scoreScr = new Score();
    this.scoreScr.init();

    this.registerScr = new Register();
    this.registerScr.init();
  }
}
